import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiResponse } from "../../../types/APIResponse";
import api from "../../../utils/constants/api";
import { apiEndpoints } from "../../../utils/constants/apiEndpoints";
import { PricingConfiguration } from "../../../types/pricingConfigurationTypes";
import { toast } from "react-toastify";

// Async Thunks
export const fetchPricingConfiguration = createAsyncThunk<PricingConfiguration, void, { rejectValue: string }>("pricingConfiguration/fetchPricingConfiguration", async (_, { rejectWithValue }) => {
  try {
    const response = await api.get<ApiResponse<PricingConfiguration>>(apiEndpoints.pricingConfig.getAll);
    if (response?.success) {
      return response.data;
    } else {
      throw new Error(response.message || "Failed to fetch pricing configuration.");
    }
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || error.message);
  }
});

export const createPricingConfiguration = createAsyncThunk<PricingConfiguration, PricingConfiguration, { rejectValue: string }>("pricingConfiguration/createPricingConfiguration", async (data, { rejectWithValue }) => {
  try {
    const response = await api.post<ApiResponse<PricingConfiguration>>(apiEndpoints.pricingConfig.create, { data });
    if (response?.success) {
      toast.success("Pricing configuration create successfully");
      return response.data;
    } else {
      throw new Error(response.message || "Failed to add pricing configuration.");
    }
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const updatePricingConfiguration = createAsyncThunk<PricingConfiguration, PricingConfiguration, { rejectValue: string }>("pricingConfiguration/updatePricingConfiguration", async (updatedPricingConfigurationData, { rejectWithValue }) => {
  try {
    const response = await api.put<ApiResponse<PricingConfiguration>>(`${apiEndpoints.pricingConfig.update}/${updatedPricingConfigurationData?.id}`, { data: updatedPricingConfigurationData });
    if (response?.success) {
      toast.success("Pricing configuration updated successfully");
      return { ...response.data };
    } else {
      throw new Error(response.message || "Failed to update pricing configuration.");
    }
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});
